import { useState } from 'react';
import { CONTACT } from '../data/siteData';

const BASE_MESSAGE = 'HELP - I need roadside assistance.';

function buildSmsHref(body) {
  const isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const separator = isiOS ? '&' : '?';
  return `sms:+16043988866${separator}body=${encodeURIComponent(body)}`;
}

export default function TextNowLink({ children, className = '', title = 'Text Jonny’s Towing with your location' }) {
  const [locating, setLocating] = useState(false);

  function openSms(body = BASE_MESSAGE) {
    window.location.href = buildSmsHref(body);
  }

  function handleClick(event) {
    event.preventDefault();
    if (locating) return;

    if (!window.isSecureContext || !navigator.geolocation) {
      openSms(`${BASE_MESSAGE}\nLocation: please enter your current location.`);
      return;
    }

    setLocating(true);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude.toFixed(6);
        const lng = position.coords.longitude.toFixed(6);
        const accuracy = Math.round(position.coords.accuracy || 0);
        const mapsUrl = `https://maps.google.com/?q=${lat},${lng}`;
        const accuracyText = accuracy > 0 ? ` (approx. ±${accuracy} m)` : '';
        const body = `${BASE_MESSAGE}\n\nMy current location:\n${mapsUrl}\nGPS: ${lat}, ${lng}${accuracyText}`;
        setLocating(false);
        openSms(body);
      },
      () => {
        setLocating(false);
        openSms(`${BASE_MESSAGE}\nLocation: please enter your current location.`);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 30000,
      },
    );
  }

  return (
    <a
      className={className}
      href={CONTACT.textHref}
      data-roka-cta="text_dispatch"
      data-roka-label="Text dispatch"
      onClick={handleClick}
      aria-busy={locating}
      title={title}
    >
      {locating ? 'Getting location…' : children}
    </a>
  );
}
